import { render, staticRenderFns } from "./BetSlipOdds.vue?vue&type=template&id=1e1bf8aa&scoped=true&"
import script from "./BetSlipOdds.vue?vue&type=script&lang=js&"
export * from "./BetSlipOdds.vue?vue&type=script&lang=js&"
import style0 from "./BetSlipOdds.vue?vue&type=style&index=0&id=1e1bf8aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1bf8aa",
  null
  
)

export default component.exports